/*
 * Helper function to genrate filenames for certificates
 */
import moment from 'moment';

export function generateCertificateFilename({
    classroomName,
    studentName = null,
    startDate,
    endDate
}) {
    return `${classroomName}_${startDate}_${endDate}${studentName ? `_${studentName}` : ''}`;
}

/**
 * Format date as 'DDMM'
 */
export function formatDateForFilename(date) {
    return moment(date).format('DDMM');
}

export function formatDateForGemCount(date) {
    return moment(date).format('DD-MM-YYYY');
}




// WEBPACK FOOTER //
// ./helpers/generate-certificate-filename.js